/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_403_Log_In_Timeout_Issue_DescriptionInputs */

const en_dialog_403_log_in_timeout_issue_description = /** @type {(inputs: Dialog_403_Log_In_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your login session has expired. Please return to Forest and log in again.`)
};

const ar_dialog_403_log_in_timeout_issue_description = /** @type {(inputs: Dialog_403_Log_In_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتهت صلاحية جلسة تسجيل الدخول الخاصة بك. يرجى العودة إلى Forest وتسجيل الدخول مرة أخرى.`)
};

const de_dialog_403_log_in_timeout_issue_description = /** @type {(inputs: Dialog_403_Log_In_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Anmeldesitzung ist abgelaufen. Bitte kehren Sie zu Forest zurück und melden Sie sich erneut an.`)
};

const es_dialog_403_log_in_timeout_issue_description = /** @type {(inputs: Dialog_403_Log_In_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su sesión de inicio de sesión ha caducado. Vuelva a Forest e inicie sesión de nuevo.`)
};

const fr_dialog_403_log_in_timeout_issue_description = /** @type {(inputs: Dialog_403_Log_In_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre session de connexion a expiré. Veuillez retourner à Forest et vous reconnecter.`)
};

const it_dialog_403_log_in_timeout_issue_description = /** @type {(inputs: Dialog_403_Log_In_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua sessione di accesso è scaduta. Ti preghiamo di tornare su Forest ed effettuare nuovamente l'accesso.`)
};

const ja_dialog_403_log_in_timeout_issue_description = /** @type {(inputs: Dialog_403_Log_In_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログインの有効期限が切れました。Forestに戻って再度ログインしてください。`)
};

const ko_dialog_403_log_in_timeout_issue_description = /** @type {(inputs: Dialog_403_Log_In_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인 세션이 만료되었습니다. Forest으로 돌아가 다시 로그인해 주세요.`)
};

const pt_br_dialog_403_log_in_timeout_issue_description = /** @type {(inputs: Dialog_403_Log_In_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua sessão de login expirou. Por favor, retorne ao Forest e faça login novamente.`)
};

const ru_dialog_403_log_in_timeout_issue_description = /** @type {(inputs: Dialog_403_Log_In_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Срок действия вашей сессии входа истек. Пожалуйста, вернитесь в Forest и войдите снова.`)
};

const th_dialog_403_log_in_timeout_issue_description = /** @type {(inputs: Dialog_403_Log_In_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เซสชันการเข้าสู่ระบบของคุณหมดอายุแล้ว กรุณากลับไปที่ Forest และเข้าสู่ระบบใหม่อีกครั้ง`)
};

const tr_dialog_403_log_in_timeout_issue_description = /** @type {(inputs: Dialog_403_Log_In_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oturumunuzun süresi doldu. Lütfen Forest'a geri dönüp tekrar giriş yapın.`)
};

const zh_cn_dialog_403_log_in_timeout_issue_description = /** @type {(inputs: Dialog_403_Log_In_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的登录已过期。请返回 Forest 并重新登录。`)
};

const zh_tw_dialog_403_log_in_timeout_issue_description = /** @type {(inputs: Dialog_403_Log_In_Timeout_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的登入已逾時。請回到 Forest 並重新登入。`)
};

/**
* | output |
* | --- |
* | "Your login session has expired. Please return to Forest and log in again." |
*
* @param {Dialog_403_Log_In_Timeout_Issue_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_403_log_in_timeout_issue_description = /** @type {((inputs?: Dialog_403_Log_In_Timeout_Issue_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_403_Log_In_Timeout_Issue_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_403_log_in_timeout_issue_description(inputs)
	if (locale === "ar") return ar_dialog_403_log_in_timeout_issue_description(inputs)
	if (locale === "de") return de_dialog_403_log_in_timeout_issue_description(inputs)
	if (locale === "es") return es_dialog_403_log_in_timeout_issue_description(inputs)
	if (locale === "fr") return fr_dialog_403_log_in_timeout_issue_description(inputs)
	if (locale === "it") return it_dialog_403_log_in_timeout_issue_description(inputs)
	if (locale === "ja") return ja_dialog_403_log_in_timeout_issue_description(inputs)
	if (locale === "ko") return ko_dialog_403_log_in_timeout_issue_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_403_log_in_timeout_issue_description(inputs)
	if (locale === "ru") return ru_dialog_403_log_in_timeout_issue_description(inputs)
	if (locale === "th") return th_dialog_403_log_in_timeout_issue_description(inputs)
	if (locale === "tr") return tr_dialog_403_log_in_timeout_issue_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_403_log_in_timeout_issue_description(inputs)
	return zh_tw_dialog_403_log_in_timeout_issue_description(inputs)
});